<template>
  <div class="about">
    <v-header/>
    <v-sidebar/>
    <div :class="collapse==true?'content-box1':'content-box'">
      <v-tags></v-tags>
      <ul class="infinite-list content" style="overflow: auto;">
        <div class="container" style="overflow-x:auto">
          <!-- 修复后的路由缓存写法 -->
          <router-view v-slot="{ Component, route }">
            <transition name="move" mode="out-in">
              <!-- key 必须加，保证路由切换能正确识别缓存 -->
              <keep-alive :include="tagsList" max="10">
                <component
                    :is="Component"
                    :key="route.path"
                    v-if="Component"
                />
              </keep-alive>
            </transition>
          </router-view>
        </div>
      </ul>
    </div>
    <!--    合同到期提醒 弹框-->
    <el-dialog title="合同到期提醒" v-model="contractDeadlineDialog" width="1300px" @close="onContractReminderClose">
      <el-button type="primary" @click="selectContractDeadline">刷新列表</el-button>

        <el-tabs v-model="contractActiveName" class="demo-tabs" @tab-click="contractTabsHandleClick">
          <el-tab-pane label="全职" name="first">
            <el-table
                :data="contractDeadline"
                height="530px"
                :row-style="{height: '35px'}"
                border
                style="width: 100%"
            >
              <el-table-column label="id" width="150" align="center" show-overflow-tooltip prop="coachid"/>
              <el-table-column label="工号" width="150" align="center" show-overflow-tooltip prop="workNumber"/>
              <el-table-column label="姓名" width="150" align="center" show-overflow-tooltip prop="coachname"/>
              <el-table-column label="个人电话" width="150" align="center" show-overflow-tooltip prop="coachphone"/>
              <el-table-column label="签署主体" align="center" show-overflow-tooltip prop="signContractFirstPartyName"/>
              <el-table-column label="部门" align="center" show-overflow-tooltip prop="deptName"/>
              <el-table-column label="操作" width="100" fixed="right" align="center">
                <template #default="scope">
                  <el-button @click="contractExtension(scope.row)" style="width: 14px;" size="small" type="text">续签合同
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="兼职" name="fourth"><el-table
              :data="contractDeadline2"
              height="530px"
              :row-style="{height: '35px'}"
              border
              style="width: 100%"
          >
            <el-table-column label="id" width="150" align="center" show-overflow-tooltip prop="coachid"/>
            <el-table-column label="工号" width="150" align="center" show-overflow-tooltip prop="workNumber"/>
            <el-table-column label="姓名" width="150" align="center" show-overflow-tooltip prop="coachname"/>
            <el-table-column label="个人电话" width="150" align="center" show-overflow-tooltip prop="coachphone"/>
            <el-table-column label="签署主体" align="center" show-overflow-tooltip prop="signContractFirstPartyName"/>
            <el-table-column label="部门" align="center" show-overflow-tooltip prop="deptName"/>
            <el-table-column label="操作" width="100" fixed="right" align="center">
              <template #default="scope">
                <el-button @click="contractExtension(scope.row)" style="width: 14px;" size="small" type="text">续签合同
                </el-button>
              </template>
            </el-table-column>
          </el-table></el-tab-pane>
        </el-tabs>


    </el-dialog>
    <contract-extension @refreshList="selectContractDeadline" ref="contract" :item="detailItem"/>
  </div>
</template>
<script>
import vHeader from "../../components/Header";
import vSidebar from "../../components/Sidebar";
import vTags from "../../components/Tags.vue";
import contractExtension from "../coach/roster/components/ContractExtension";
import {contractExpireCoachList} from "@/api/coachRoster";


export default {
  components: {
    contractExtension,
    vHeader,
    vSidebar,
    vTags
  },
  data() {
    return {
      detailItem: null,
      contractDeadline: [],//全职合同到期提醒
      contractDeadline2: [],//兼职合同到期提醒
      contractDeadlineDialog: false,
      contractActiveName: 'first'
    }
  },
  methods: {
    //tab点击后触发
    contractTabsHandleClick(tab, event) {
      console.log(tab, event)
    },
    /**
     * 调用子组件方法打开弹出层
     */
    contractExtension(item) {
      this.detailItem = item;
      this.detailItem.coachId = item.coachid;
      this.$refs.contract.openDialog();
    },
    /**
     * 合同到期提醒静默控制:用户手动关闭一次后,4 小时内不再自动弹出
     * 用 localStorage 记录关闭时间,刷新页面/重新进入首页也生效
     */
    isContractReminderMuted() {
      const t = Number(localStorage.getItem('contract_reminder_dismiss_time'));
      if (!t) return false;
      return Date.now() - t < 4 * 60 * 60 * 1000; // 4 小时
    },
    // 用户主动关闭弹框(点 X / 按 ESC / 点遮罩)时记录静默时间
    onContractReminderClose() {
      localStorage.setItem('contract_reminder_dismiss_time', Date.now());
    },
    /**
     * 查询合同到期列表
     */
    selectContractDeadline() {
      contractExpireCoachList().then(val => {
        if (val.code === 200 && val.data && val.data.length > 0) {
          //console.info(val.data)
          const contractDeadline1 = val.data.filter(item => item.type === 1)
          const contractDeadline2 = val.data.filter(item => item.type === 2)
          this.contractDeadline = contractDeadline1;
          this.contractDeadline2 = contractDeadline2;
          // 4 小时内已手动关闭过,本次不再自动弹出提醒(数据照常加载,只是不弹框)
          if (this.isContractReminderMuted()) return;
          this.contractDeadlineDialog = true;
        }
      })
    },
  },
  created() {
    this.selectContractDeadline();

  },

  computed: {

    tagsList() {
      console.log(this.$store.state.tagsList)
      return this.$store.state.tagsList.map(item => item.name);
    },
    collapse() {
      return this.$store.state.collapse;
    }
  }
};
</script>
<style>
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
</style>
